import axios from 'axios';
import './axiosInterceptor';

export const PASARELA = process.env.VUE_APP_URLPASARELA;

export const Productos = {
    // Listar productos con paginación y filtros
    getProductos(params) {
        return axios.get(PASARELA + "/administracion/productos", { params });
    },

    // Obtener un producto por ID
    getProducto(id) {
        return axios.get(`${PASARELA}/administracion/producto/${id}`);
    },

    // Crear un nuevo producto
    createProducto(payload) {
        return axios.post(PASARELA + "/administracion/producto", payload);
    },

    // Actualizar un producto existente
    updateProducto(payload) {
        return axios.put(PASARELA + "/administracion/producto", payload);
    },

    // Eliminar un producto (Soft Delete)
    deleteProducto(id) {
        return axios.delete(`${PASARELA}/administracion/producto/${id}`);
    },

    // Cambiar el estado activo/inactivo de un producto
    toggleActivoProducto(id, activo) {
        return axios.put(`${PASARELA}/administracion/producto/${id}/activo`, { activo });
    }
};
